import PropTypes from 'prop-types';
import React from 'react';

import { P } from '@components/typography';
import { restaurantPropTypes } from '@nandosaus/prop-types';
import { RestaurantStatus } from '@components/restaurant-status';
import { Flex } from '@components/grid';
import styled from 'styled-components';
import { useFeature } from '@hooks/use-feature';
import { ContentSubHeader, PageHeaderBlock } from '../content-image';
import { convertToSlug } from '../../utils/convert-to-slug';
import { navigation } from '../../constants';

const StatusHeaderBar = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.05);
  background-color: white;
`;

const RestaurantPageHeader = ({ state, heading, subheading, backgroundImage, restaurant }) => {
  const breadcrumbs = {
    title: heading,
    ancestors: [
      {
        title: 'Restaurants',
        url: navigation.RESTAURANTS,
      },
      {
        title: state,
        url: `${navigation.RESTAURANTS}/${convertToSlug(state)}`,
      },
    ],
  };

  const showCmsRestaurantPages = useFeature('show-cms-restaurant-pages');

  return (
    <>
      <PageHeaderBlock
        hasBlackOverlayImage
        backgroundImage={[backgroundImage]}
        heading={heading}
        subheading={
          !!subheading && (
            <P mt={1} mb={1} color="white" fontWeight="bold">
              {subheading}
            </P>
          )
        }
        hasHeadingHighlight
        py="0"
      />
      {showCmsRestaurantPages && (
        <StatusHeaderBar>
          <RestaurantStatus restaurant={restaurant} displayHeaderBar />
        </StatusHeaderBar>
      )}
      <ContentSubHeader breadcrumbs={breadcrumbs} />
    </>
  );
};

RestaurantPageHeader.propTypes = {
  restaurant: restaurantPropTypes.isRequired,
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  state: PropTypes.string.isRequired,
  backgroundImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
};

RestaurantPageHeader.defaultProps = {
  backgroundImage: undefined,
  subheading: undefined,
};

export { RestaurantPageHeader };
